import { Statistic,Tooltip } from 'antd'
import { StyledComponentProps } from 'main/config/theme/Theme'
import React, { CSSProperties } from 'react'
import styled from 'styled-components'
import { LoadingCP } from '../loading/LoadingCP'

interface IStatisticCardCPProps {
    title?: string
    value?: number | string
    precision?: number
    valueStyle?: CSSProperties
    prefix?: JSX.Element
    suffix?: JSX.Element
    fontSize?: string
    fontWeight?: number
    color?: string
    loading?: boolean
    valor2?:number | string
}

/**
 * Card para exibição de statisticas
 * @param {IStatisticCardCPProps} props
 * @author renatoassis
 */
export function StatisticCardCP(props: IStatisticCardCPProps): JSX.Element {
    return (
        <StatisticsWrapperSCP style={{ color: props.color }}>
            {
                props.prefix &&
                <PrefixIconWrapper>
                    {props.prefix}
                </PrefixIconWrapper>
            }
            {
                props.loading ?
                    <LoadingCP/>
                    :
                    <InfoWrapperSCP>
                        <Statistic
                            title={props.title}
                            value={props.value}
                            precision={props.precision}
                            valueStyle={{ ...props.valueStyle }}
                            suffix={props.suffix}
                        />
                        <Tooltip title="Este é o valor líquido - Tudo que foi pago no mês relativo a vendas, sem levar em consideração Receitas e Despesas">
                            <SubValor>
                                {props.valor2}
                            </SubValor>
                        </Tooltip>
                    </InfoWrapperSCP>

            }

        </StatisticsWrapperSCP>
    )

}

const SubValor = styled.div`
    position: absolute;
    right: 0px;
    bottom: 0px;
    margin-right: 7px;
    font-weight: 557;
    color: #8c8c8c
`

const StatisticsWrapperSCP = styled.div<{ style: CSSProperties }>`
    display: flex;
    background: #fff;
    padding: 10px;
    border-radius: 8px;
    margin: 0 10px 10px 10px;
    height: 100px;
    position: relative;
    &::before{
        content: ''; 
        width: 5px;
        height: 100%;
        border-radius: 8px 0 0 8px;
        top: 0;
        left: 0;
        position: absolute;
        background: ${(props): string | undefined => props.style.color}
    }

    .ant-statistic-content-value-int{
        font-weight: 600;
    }
`

const PrefixIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 35px 0 15px;

    &::after{
        content: '';
        width: 2px;
        height: 46%;
        top: 0;
        border-radius: 2px;
        bottom: 0;
        margin: auto 0;
        left: 6em;
        position: absolute;
        background: #e2e2e2;
    }

`

const InfoWrapperSCP = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    padding-right: 15px;

    .ant-statistic{
        line-height: 1.2;
        font-family: ${(props: StyledComponentProps): string => props.theme.titleFontFamily};

        .ant-statistic-content{
            font-weight: 600;
            font-size: 18px;
            color: ${(props: StyledComponentProps): string => props.theme.darkGray};
        }

        .ant-statistic-title{
            font-weight: 500;
            font-size: 13px;
            color: ${(props: StyledComponentProps): string => props.theme.primaryColor};
        }

    }
`
